import React from "react";
import "./StarRating.scss";

interface StarRatingProps {
  value: number;
  // Larger type for the aggregate card; cards use the default.
  size?: "sm" | "lg";
}

// Two stacked rows of stars with the filled row clipped to the score, so a 4.3
// reads as four and a bit rather than snapping to a whole star.
const StarRating: React.FC<StarRatingProps> = ({ value, size = "sm" }) => {
  const percent = Math.max(0, Math.min(100, (value / 5) * 100));

  return (
    <span
      className={`star-rating ${size === "lg" ? "star-rating-lg" : ""}`}
      role="img"
      aria-label={`${value.toFixed(1)} out of 5`}
    >
      <span className="star-empty">★★★★★</span>
      <span className="star-fill" style={{ width: `${percent}%` }}>
        ★★★★★
      </span>
    </span>
  );
};

export default StarRating;
